let offset = 0;

export function setServerNow(serverNow: number) {
  offset = serverNow - Date.now();
}

export function serverNow(): number {
  return Date.now() + offset;
}

export function formatRemaining(ms: number): string {
  if (ms <= 0) return '0:00';
  const s = Math.ceil(ms / 1000);
  const d = Math.floor(s / 86400);
  const h = Math.floor((s % 86400) / 3600);
  const m = Math.floor((s % 3600) / 60);
  const sec = s % 60;
  if (d > 0) return `${d} d ${h} h`;
  if (h > 0) return `${h} h ${m} min`;
  return `${m}:${String(sec).padStart(2, '0')}`;
}

export function formatLimit(sec: number): string {
  if (sec < 60) return `${sec} s`;
  if (sec < 3600) return `${sec / 60} min`;
  return `${sec / 3600} h`;
}
